import { utils } from '@tfo/common'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import ReadReport from './components/report/ReadReport'
import ReadReportBackoffice from './components/report/ReadReportBackoffice'
import Individual from './containers/candidate/Individual'
import FinalizeSignature from './containers/candidate/views/finalize-signature/FinalizeSignature'
import StartIndividual from './containers/candidate/views/start-individual/StartIndividual'
import EmailSent from './containers/email-sent/EmailSent'
import Faq from './containers/Faq/Faq'
import LoginIndividual from './containers/login-individual/LoginIndividual'
import PageNotFound from './containers/page-not-found/PageNotFound'
import RootStore from './stores/RootStore'
interface IMain {
	rootStore?: RootStore
}

@observer
class Main extends React.Component<IMain & RouteComponentProps> {
	render() {
		return (
			<Switch>
				<Route exact path="/" component={() => {
					if(utils.loggedIn()) {
						return <Redirect to="/candidate" />
					}

					return <Redirect to="/login" />;
				}} />

				<Route exact path="/login/:loginType?" component={() => {
					if(utils.loggedIn()) {
						return <Redirect to="/" />
					}

					return <LoginIndividual />;
				}} />

				<Route path="/report-backoffice/:orderId" component={() => <ReadReportBackoffice /> } />

				{/* can't use the BACKOFFICE_TOKEN from @tfoCommon as we get some weird compilation error. */}
				<Route path="/report/:orderId" component={() => (utils.loggedIn() || utils.loggedIn('tfoBackOffice') )
					? <ReadReport />
					: <Redirect to="/login" />} />

				<Route path="/approval/:orderId" component={() => utils.loggedIn()
					? <StartIndividual />
					: <Redirect to="/login" />} />

				<Route path="/signature/:orderId/accepted" component={() => utils.loggedIn()
					? <FinalizeSignature />
					: <Redirect to="/login" />} />	

				<Route exact path="/candidate" component={() => {
					if(utils.loggedIn()) {
						return <Individual />
					}

					return <Redirect to="/login" />;
				}} />

				<Route exact path="/faq" component={() => <Faq />} />

				<Route exact path="/emailSent" component={() => <EmailSent />} />

				<Route component={() => <PageNotFound />} />

			</Switch>
		)
	}
}
export default inject('rootStore')(withRouter(Main))
